import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";

function LargeList_Chart({data, title, date}) {

    const dataName = title==='미처리업무' ? '요청마감일' : '일시';
    const navigate = useNavigate();
    return (
        <div className={`overflow-y-auto w-full scroll-hidden py-2`}>
            <table className={` large-listChart-table`}>
                <thead className={` sticky top-0`}>
                    <tr className={``}>
                        <th className={`large-listChart-table-th w-[90px] `}>{dataName}</th>
                        <th className={`large-listChart-table-th w-[90px] `}>구분</th>
                        <th className={`large-listChart-table-th w-[120px] `}>등록자</th>
                        <th className={`large-listChart-table-th`}>내역</th>
                        <th className={`large-listChart-table-th w-[40px]`}>관리</th>
                    </tr>
                </thead>
                <tbody  className={``}>
                {data.map((each, index) => (
                    <tr key={`${title}_` + index}>
                        <td className={`large-listChart-table-td`}>{ each.dateTime?.substring(0,10)}</td>
                        <td className={`large-listChart-table-td`}>{each.title}</td>
                        <td className={`large-listChart-table-td`}>{each.userName}</td>
                        <td className={`large-listChart-table-td text-left overflow-ellipsis text-nowrap`}>{each.name}</td>
                        <td className={`large-listChart-table-td text-center hover:cursor-pointer`} onClick={()=>{navigate(each.link+'/'+each.id) }}>
                            <FontAwesomeIcon icon={faMagnifyingGlass}
                                             className={`line-height-30`}/>
                        </td>
                    </tr>
                ))}
                {data?.length<1 &&
                    <tr>
                        <td colSpan={5} className={`border h-[160px]`}>조회 내역이 없습니다.</td>
                    </tr>
                }
                </tbody>
            </table>
        </div>
    );
}

export default LargeList_Chart;